import { render, staticRenderFns } from "./PageContontHeader.vue?vue&type=template&id=70986c98&scoped=true&"
import script from "./PageContontHeader.vue?vue&type=script&lang=ts&"
export * from "./PageContontHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PageContontHeader.vue?vue&type=style&index=0&id=70986c98&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70986c98",
  null
  
)

export default component.exports